//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NumberInputSpinner from '@/components/vue-number-input-spinner/src/components/NumberInputSpinner.vue'
import { jssdk, isIphonex } from '@runwork/runwork-help'
export default {
  props: {
    question: {
      type: Object,
      default: () => {
        options: []
      },
    },
  },
  components: { NumberInputSpinner },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
  },
  data() {
    return {}
  },
  methods: {
    addQuestion() {
      this.$emit('onadd', this.question)
      this.$emit('popup-close')
    },
  },
}
